import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4ed3dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card-title row wrap" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Links ")
const _hoisted_4 = { class: "q-px-lg q-mt-xs column" }
const _hoisted_5 = {
  key: 0,
  class: "equipment-link q-mb-lg"
}
const _hoisted_6 = { class: "row justify-between col-12" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "row justify-between col-12" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_EditMenu = _resolveComponent("EditMenu")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_AddOrUpdateEquipmentLinkPopin = _resolveComponent("AddOrUpdateEquipmentLinkPopin")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.equipment)
          ? (_openBlock(), _createBlock(_component_q_card, {
              key: 0,
              class: "q-mb-lg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      (!_ctx.isUserUnknownOrGuest())
                        ? (_openBlock(), _createBlock(_component_AddButton, {
                            key: 0,
                            "data-test": "add-link-button",
                            "popin-type": _ctx.popinTypeEnum.LINK
                          }, null, 8 /* PROPS */, ["popin-type"]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_separator),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("dl", null, [
                    (_ctx.showQuantumLink())
                      ? (_openBlock(), _createElementBlock("dt", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("a", {
                              "data-test": "link-href",
                              href: `https://navigator.phusionim.com/${_ctx.getAsset()}?type=Tag&TagNumber=${_ctx.getEquipmentTitle()}`,
                              target: "_blank",
                              class: "q-pt-sm col-9"
                            }, " Quantum ", 8 /* PROPS */, _hoisted_7),
                            (!_ctx.isUserUnknownOrGuest())
                              ? (_openBlock(), _createBlock(_component_EditMenu, {
                                  key: 0,
                                  class: "col-2",
                                  onOnEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickEditLink(_ctx.link))),
                                  onOnDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDelete(_ctx.link)))
                                }))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.equipmentLinks, (link) => {
                      return (_openBlock(), _createElementBlock("dt", {
                        key: link.id,
                        class: "equipment-link q-mb-lg"
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            "data-test": "link-href",
                            href: link.link,
                            target: "_blank",
                            class: "q-pt-sm col-9"
                          }, _toDisplayString(link.title), 9 /* TEXT, PROPS */, _hoisted_9),
                          (!_ctx.isUserUnknownOrGuest())
                            ? (_openBlock(), _createBlock(_component_EditMenu, {
                                key: 0,
                                class: "col-2",
                                onOnEdit: ($event: any) => (_ctx.onClickEditLink(link)),
                                onOnDelete: ($event: any) => (_ctx.onDelete(link))
                              }, null, 8 /* PROPS */, ["onOnEdit", "onOnDelete"]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_AddOrUpdateEquipmentLinkPopin, {
          "is-edit-mode": _ctx.isEditMode,
          "current-link": _ctx.currentLink,
          onOnClose: _ctx.onClosePopin
        }, null, 8 /* PROPS */, ["is-edit-mode", "current-link", "onOnClose"]),
        _createVNode(_component_ConfirmDialog, {
          title: "Delete Link",
          message: _ctx.confirmDeleteLinkMessage,
          open: _ctx.displayConfirmDeleteDialog,
          onOnClose: _ctx.onClose,
          onOnConfirm: _ctx.onConfirmDelete
        }, null, 8 /* PROPS */, ["message", "open", "onOnClose", "onOnConfirm"])
      ]))
    : _createCommentVNode("v-if", true)
}